export default ({ pathname }, route) => {
  if (pathname === route.path) {
    /**
     * Replaced by Helmet
     */
    // document.title = route.name;
  }
};
